import { render, staticRenderFns } from "./VueQrcodeReader.vue?vue&type=template&id=252ec95e&scoped=true&"
import script from "./VueQrcodeReader.vue?vue&type=script&lang=ts&"
export * from "./VueQrcodeReader.vue?vue&type=script&lang=ts&"
import style0 from "./VueQrcodeReader.vue?vue&type=style&index=0&id=252ec95e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ec95e",
  null
  
)

export default component.exports